var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditarBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.351 3.33914L1.34665 14.3446C1.29122 14.4 1.25147 14.4704 1.23236 14.5457L0.0126273 19.4414C-0.0236856 19.589 0.0195076 19.7457 0.126917 19.8531C0.208335 19.9345 0.319184 19.9796 0.43271 19.9796C0.467494 19.9796 0.503042 19.9754 0.537444 19.9666L5.43318 18.7469C5.50963 18.7278 5.57882 18.688 5.63424 18.6326L16.6397 7.62788L12.351 3.33914Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3657 1.83886L18.1406 0.613783C17.3222 -0.204977 15.8953 -0.204212 15.0773 0.613783L13.5767 2.11446L17.865 6.40282L19.3657 4.90214C19.7747 4.49314 19.9998 3.94922 19.9998 3.3705C19.9998 2.79179 19.7747 2.24786 19.3657 1.83886Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4886 16.713H10.4123C9.57755 16.713 8.90088 17.3897 8.90088 18.2244V18.4682C8.90088 19.303 9.57755 19.9796 10.4123 19.9796H18.4886C19.3233 19.9796 20 19.303 20 18.4682V18.2244C20 17.3897 19.3233 16.713 18.4886 16.713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarBlanco);
export default __webpack_public_path__ + "static/media/editar_blanco.4752278303540979ce02f6eba0c52bee.svg";
export { ForwardRef as ReactComponent };